import { Component, Inject, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface QuestionAnswer {
  question: string;
  formControl: FormControl;
}

@Component({
  selector: "app-question-answer-text",
  templateUrl: "./question-answer-text.component.html",
  styleUrls: ["./question-answer-text.component.scss"],
})
export class QuestionAnswerTextComponent implements OnInit {
  question: string;
  formControl: FormControl;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { questionAnswer: QuestionAnswer },
  ) {
    this.question = this.data.questionAnswer.question;

    this.formControl = this.data.questionAnswer.formControl;
  }

  ngOnInit(): void {}
}
